import { render } from "./DeletedCustomersList.vue?vue&type=template&id=9015af54"
import script from "./DeletedCustomersList.vue?vue&type=script&lang=js"
export * from "./DeletedCustomersList.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__